<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.member.updateWebsiteEmpty.p1')}}
    {{news.textParams[2]}}
    {{$t('news.template.member.updateWebsiteEmpty.p2')}}
  </div>
</template>
